import React from 'react';

const CloseIcon = props => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" {...props}>
      <rect
        x="1.31281"
        y="0.502155"
        width="19"
        height="1.5"
        transform="rotate(45 1.31281 0.502155)"
        fill="currentColor"
      />
      <rect
        x="0.252155"
        y="13.9372"
        width="19"
        height="1.5"
        transform="rotate(-45 0.252155 13.9372)"
        fill="currentColor"
      />
    </svg>
  );
};

export default CloseIcon;
